import { useCallback, useEffect, useState } from "react"
import api from "../../utils/api"

// Units a manager assigned to the signed-in person that wait for them to
// Approve & Pay. Shown in the dashboard bell and the Rentals tenant view until
// they approve or decline.
export function useTenancyInvitations(enabled = true) {
  const [invitations, setInvitations] = useState([])
  const [loading, setLoading] = useState(false)

  const reload = useCallback(async () => {
    if (!enabled) {
      setInvitations([])
      return
    }
    setLoading(true)
    try {
      const response = await api.get("/frp/tenancy-invitations/mine")
      setInvitations(Array.isArray(response?.data?.invitations) ? response.data.invitations : [])
    } catch {
      // A missing notification must never break the dashboard.
      setInvitations([])
    } finally {
      setLoading(false)
    }
  }, [enabled])

  useEffect(() => {
    reload()
  }, [reload])

  return { invitations, loading, reload }
}
